import { useSelector } from "react-redux";

// Custom Hook for Filtering Games
const useFilterGamesByType = () => {
  const { getAllgamesList } = useSelector((state) => state?.crash);

  // Function to filter games by type
  const filterByGameType = (gameType) => {
    return getAllgamesList?.filter((game) => game.game_type === gameType) || [];
  };

  return filterByGameType;
};

export default useFilterGamesByType;
